var _this = this;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useReducer } from 'react';
import { Button, Spinner } from 'reactstrap';
import notifications from "../services/notifications";
import security from "../services/security";
import translator, { t } from "../services/translator";
import logger from "../services/logger";
import environment from "../services/environment";
import { Provider } from "../services/context";
import object from "../services/utils/object";

var reducerUpdater = function reducerUpdater(state, newState) {
  return newState;
};
/**
 * Passer par une fonction composant évite des problèmes de reload
 * comme on métrise mieux à quel moment le composant peut s'update.
 */


var UpperProvider = function UpperProvider(_ref) {
  var editionMode = _ref.editionMode,
      aliasCookie = _ref.aliasCookie,
      typeCookie = _ref.typeCookie,
      children = _ref.children,
      locale = _ref.locale,
      othersProps = _objectWithoutProperties(_ref, ["editionMode", "aliasCookie", "typeCookie", "children", "locale"]);

  var _useReducer = useReducer(reducerUpdater, null),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      upperState = _useReducer2[0],
      updateState = _useReducer2[1];
  /**
   * @param {bool|null} closeTitle Affiche le bouton de fermeture de la modale dans le titre
   */


  var openModal = function openModal(title, content, actions, size, closeTitle, props) {
    updateState(_objectSpread(_objectSpread({}, upperState), {}, {
      modal: {
        show: true,
        title: title,
        content: content,
        actions: actions,
        size: size,
        closeTitle: closeTitle,
        props: props
      }
    }));
  };

  var closeModal = function closeModal() {
    updateState(_objectSpread(_objectSpread({}, upperState), {}, {
      modal: {
        show: false,
        title: null,
        content: null,
        closeTitle: true,
        actions: []
      }
    }));
  };

  var confirm = function confirm(description, _onClick) {
    return upperState.openModal( /*#__PURE__*/React.createElement("h3", null, t('do_you_confirm')), description, /*#__PURE__*/React.createElement(Button, {
      color: "default",
      onClick: function onClick() {
        _this.closeModal();

        _onClick && _onClick();
      }
    }, t('confirm')), null, true, {
      backdrop: false
    });
  };

  var initializeContext = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var providerLocale;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              providerLocale = locale || object.get('locale', security.user, locale || navigator.language || environment.get('default_locale'));

              if (providerLocale && providerLocale.indexOf('-') !== -1) {
                providerLocale = providerLocale.substr(0, providerLocale.indexOf('-'));
              }

              updateState(_objectSpread(_objectSpread(_objectSpread({}, upperState), othersProps), {}, {
                title: '',
                traductionLoaded: false,
                modal: {
                  show: false,
                  title: null,
                  content: null,
                  closeTitle: true,
                  props: {},
                  actions: []
                },
                openModal: openModal,
                closeModal: closeModal,
                confirm: confirm,
                loading: true,
                locale: providerLocale
              }));
              _context.prev = 3;
              _context.next = 6;
              return translator.setLocale(providerLocale);

            case 6:
              updateState({
                loading: false,
                locale: providerLocale,
                traductionLoaded: true
              });
              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](3);
              updateState({
                loading: false
              });
              logger.error('CANNOT FETCH TRAD', '', {
                locale: locale
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 9]]);
    }));

    return function initializeContext() {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    initializeContext();
  }, [locale]);

  if (!upperState || upperState.loading || !Provider || !upperState.locale) {
    return /*#__PURE__*/React.createElement("div", {
      className: "w-100 vh-100 d-flex justify-content-center align-items-center"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Spinner, {
      color: "primary"
    })));
  }

  return /*#__PURE__*/React.createElement(Provider, {
    value: upperState,
    aliasCookie: aliasCookie,
    typeCookie: typeCookie
  }, notifications && notifications.render(), children);
};

export default UpperProvider;